import React, {Fragment, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {announcements, loadAnnouncements} from "../../store/reducers/announcement";
import makeStyles from "@mui/styles/makeStyles";
import Grid from "@mui/material/Grid";
import {TimerCountUp} from "../../controls/agyle/timer";
import {useTranslation} from "react-i18next";
import _ from "lodash";
import clsx from "clsx";
import {announcementIcon} from "../../pages/admin/announcement_admin";

export const useStyles = makeStyles((theme) => ({
    announcements: {
        background: "#F6E8B6",
        color: "#000",
        maxHeight: "10vh",
        overflow: "auto",
        margin: "5px 0",
        marginLeft: 15,
        padding: 2,
        borderRadius: 10,
    },
    announcementTitle: {
        fontWeight: "bold",
        marginLeft: 5,
    },
    list: {
        wordBreak: "break-all",
        fontSize: "small",
        marginLeft: 10
    },
}));

const Announcements = ({id = "announcements", marginRight = false}) => {
    const classes = useStyles();
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const announcementsObject = useSelector(announcements);
    const filteredForAgyle = announcementsObject.filter(item => item.system !== "UCR" && item.system !== "ED WAIT" && item.enabled);

    useEffect(() => {
        dispatch(loadAnnouncements());
    }, []);

    const renderAnnouncements = () => {
        return (
            <Fragment>
                <span className={classes.announcementTitle}>
                    {t("Announcements")}:
                </span>

                <div style={{marginTop: 0}}>
                    {filteredForAgyle.map(announcement => (
                        <div key={announcement.id} className={classes.list}>
                            <Grid container direction={"row"}>
                                <Grid item>
                                   <div style={{margin: "0 5px 0 5px", width: 25, textAlign: "center"}}>
                                       {announcement.colour && announcementIcon(announcement.colour)}
                                       {!announcement.colour && <span> &#8226; </span>}
                                   </div>
                                </Grid>
                                <Grid item> {announcement.text} </Grid>
                                <Grid item>
                                {announcement.countdownTo &&
                                    <div className={classes.announcementTitle}>
                                        <TimerCountUp
                                            time={announcement.countdownTo}
                                            limit={0}
                                            upperLimit={1}
                                            limitMessage={t("-Countdown End-")}
                                            countDown
                                        />
                                    </div>
                                }
                                </Grid>
                            </Grid>
                        </div>
                    ))}
                </div>
            </Fragment>
        );
    };

    return (
        <div id={id}>
            {_.isEmpty(filteredForAgyle) && ""}
            {!_.isEmpty(filteredForAgyle) && (
                <div className={clsx(classes.announcements, marginRight && "marginRight" , "scroll-normal-white")}>
                    {renderAnnouncements()}
                </div>
            )}
        </div>
    );
};

export default Announcements;